import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{
        backgroundColor: "#1a1a1a",
        border: "1px solid #3a3a3a",
        borderRadius: "8px",
        padding: "10px 14px",
        color: "#fff",
        fontSize: "13px",
      }}>
        <p style={{ margin: "0 0 6px", color: "#888", fontWeight: 600 }}>{label}</p>
        {payload.map((entry, index) => (
          <p key={index} style={{ margin: "3px 0", color: entry.color }}>
            {entry.name}:{" "}
            <strong>
              ${entry.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </strong>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default function LineChartComponent({ balanceHistory, spData, months, onMonthClick }) {
  if (!balanceHistory || !spData || !months || balanceHistory.length === 0) {
    return (
      <div style={{ height: "320px", display: "flex", alignItems: "center", justifyContent: "center", color: "#666" }}>
        No Data Available
      </div>
    );
  }

  const data = months.map((month, index) => ({
    name: month,
    "Black Litterman": balanceHistory[index],
    "S&P 500": spData[index],
  }));

  return (
    <div style={{ width: "100%" }}>
      <style>{`
        .ylg-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
        }
        .ylg-title {
          font-size: 15px;
          font-weight: 600;
          color: white;
        }
        .ylg-legend {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .ylg-legend-item {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          color: #ccc;
        }
        .ylg-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          display: inline-block;
        }
      `}</style>

      <div className="ylg-header">
        <span className="ylg-title">Portfolio Performance</span>
        <div className="ylg-legend">
          <span className="ylg-legend-item">
            <span className="ylg-dot" style={{ backgroundColor: "#4ade80" }} />
            Black Litterman
          </span>
          <span className="ylg-legend-item">
            <span className="ylg-dot" style={{ backgroundColor: "#f87171" }} />
            S&P 500
          </span>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={320}>
        <LineChart
          data={data}
          margin={{ top: 10, right: 60, left: 0, bottom: 5 }}
          onClick={(e) => {
            if (onMonthClick && e && e.activeLabel) onMonthClick(e.activeLabel);
          }}
        >
          <CartesianGrid stroke="#2e2e2e" vertical={false} />
          <XAxis
            dataKey="name"
            tick={{ fill: "#888", fontSize: 12 }}
            tickLine={false}
            axisLine={false}
            tickMargin={12}
          />
          <YAxis
            tick={{ fill: "#888", fontSize: 12 }}
            tickLine={false}
            axisLine={false}
            tickFormatter={(value) =>
              `$${value >= 1000 ? (value / 1000).toFixed(0) + "k" : value}`
            }
            domain={["auto", "auto"]}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            name="Black Litterman"
            type="monotone"
            dataKey="Black Litterman"
            stroke="#4ade80"
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 5, strokeWidth: 0 }}
          />
          <Line
            name="S&P 500"
            type="monotone"
            dataKey="S&P 500"
            stroke="#f87171"
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 5, strokeWidth: 0 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
